import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'js-cookie'
import { get, post } from '@/fn/ajax'
import {
  User,
  School,
  MapType,
  ResourceItem,
  ClassItem,
  DeviceItem,
  PlayerStatus,
  Language
} from '@/util/types'
import tryParseJson from '@/fn/tryParseJson'
import { LoginResult } from '@/api/auth'
import { getLanguage, getBrowserLanguage, localeMap } from '@/i18n'
import { throttle } from 'lodash'

Vue.use(Vuex)

const storePlayList = (list: ResourceItem[]) => {
  const filtered = list.filter(it => it != null)
  const json = JSON.stringify(filtered)
  localStorage.playList = json
  const cloned = JSON.parse(json)
  return cloned
}
const storePlayALL = (title: any) => {
  localStorage.playALL = JSON.stringify(title)
  return title
}

const setLong = (name: string, value: any) => {
  cookie.set(name, value, {
    path: '/',
    expires: 10 * 365 * 24 * 60 * 60 * 1000
  })
}
const getHost = () => {
  let host = ''
  const hostName = location.hostname
  if (hostName.indexOf('futureclass') > -1) {
    host = 'yinhai'
  } else {
    host = 'growlib'
  }
  return host
}
const store = new Vuex.Store({
  state: {
    user: (() => {
      const user = cookie.getJSON('user') as User | null
      return user != null && user.id > 0 ? user : null
    })(),

    lang: getLanguage(),

    school: tryParseJson(localStorage.school, []) as School,

    help: tryParseJson(localStorage.help, '') as string,

    playList: tryParseJson(localStorage.playList, []) as ResourceItem[],

    playItemIsRepeat: false,

    playItem: null as ResourceItem | null,

    playerStatus: 0 as PlayerStatus,

    chapterIndex: 0,

    classList: [] as ClassItem[],

    classId: 0,

    deviceList: [] as DeviceItem[],

    selectedDeviceIds: [] as number[],

    needRefreshMyCourse: false as boolean, // 解决bug：创建课程页保存课程后未实时刷新我的课程列表

    searchQuery: {} as object,

    playALL: tryParseJson(localStorage.playALL, {}) as object, // 新增保存的课程标题

    hostName: getHost(),

    clientParams: {} as any,

    onlineList: [] as any,

    playStatus: 'Play',

    playId: '' as any,

    playInfo: {} as any,

    viewer: null as any,

    noOnline: false as boolean,

    reviewId: 0,
  },

  getters: {
    hasLogin(state) {
      return state.user != null
    },

    currentLocale(state) {
      const lang = state.lang
      const locale = localeMap[lang]
      return locale
    }
  },

  mutations: {
    saveLogin(state, { user, lang, school, help }: LoginResult) {
      // save user to cookie
      state.user = user
      setLong('user', user)

      // save language to cookie
      const finalLang = lang || getBrowserLanguage()
      state.lang = finalLang
      setLong('lang', finalLang)

      // 做语言切换的时候，才需要 userLang
      // userLang 记录了当前用户的语言设置
      // setLong('userLang', finalLang)

      // save school to localStorage
      localStorage.school = JSON.stringify(school)
      state.school = school

      // save school to localStorage
      localStorage.help = JSON.stringify(help)
      state.help = help
    },

    setLang(state, lang: Language) {
      // save language to cookie
      const finalLang = lang || getBrowserLanguage()
      state.lang = finalLang
      setLong('lang', finalLang)
    },

    logout(state) {
      cookie.remove('user')
      cookie.remove('userLang')
      get('/api/auth/logout')
    },

    setPlayList(state, list: ResourceItem[]) {
      state.playList = list
      storePlayList(list)
    },
    setplayALL(state, list: any) {
      state.playALL = list
      storePlayALL(list)
    },

    setChapterIndex(state, index: number) {
      state.chapterIndex = index
    },

    setPlayItem(state, item: ResourceItem | null) {
      state.playItem = item
    },

    setPlayItemIsRepeat(state, status: boolean) {
      state.playItemIsRepeat = status
    },

    setPlayerStatus(state, status: PlayerStatus) {
      state.playerStatus = status
    },

    setClassList(state, list: ClassItem[] | null) {
      state.classList = list || []
    },

    setClassId(state, id: number) {
      state.classId = id
    },

    setDeviceList(state, list: DeviceItem[] | null) {
      state.deviceList = list || []
    },

    setSelectedDeviceIds(state, ids: number[] | null) {
      state.selectedDeviceIds = ids || []
    },

    setNeedRefreshMyCourse(state, flag: boolean) {
      state.needRefreshMyCourse = flag
    },

    setSearchQuery(state, searchQuery: object) {
      state.searchQuery = searchQuery
    },
    setClientParams(state, param: any) {
      state.clientParams = param
    },
    setOnlineList(state, list: any) {
      state.onlineList = list
    },
    setPlayStatus(state, status: string) {
      state.playStatus = status
    },
    setPlayId(state, id: any) {
      state.playId = id
    },
    setPlayInfo(state, info: any) {
      state.playInfo = info
    },
    setViewer(state, viewer: any) {
      state.viewer = viewer
    },
    setNoOnline(state, status: boolean) {
      state.noOnline = status
    },
    setReviewId(state, id: number) {
      state.reviewId = id
    }
  }
})

export function setPlayList(list: ResourceItem[]) {
  store.commit('setPlayList', list)
}
export function setplayALL(list: any) {
  store.commit('setplayALL', list)
}

export function addPlayItem(item: ResourceItem) {
  const list = store.state.playList
  const found = list.find(it => it.id == item.id)
  if (!found) {
    setPlayList(list.concat(item))
    return true
  }
  return false
}

export function removePlayItem(item: ResourceItem) {
  const list = store.state.playList
  const index = list.findIndex(it => it.id == item.id)
  index > -1 && list.splice(index, 1)
  setPlayList(list)
}

export function setChapterIndex(index: number) {
  store.commit('setChapterIndex', index)
}

export function setPlayItem(item: ResourceItem | null) {
  store.commit('setPlayItem', item)
}

export function setPlayItemIsRepeat(status: boolean) {
  store.commit('setPlayItemIsRepeat', status)
}

export function setPlayerStatus(status: PlayerStatus) {
  store.commit('setPlayerStatus', status)
}

export async function fetchPlayItem(id: number) {
  const { data } = await get(`/api/res/item?id=${id}`)
  const item = data.item as ResourceItem | null
  setPlayItem(item)
}

export function setClassList(list: ClassItem[] | null) {
  store.commit('setClassList', list)
}

export async function fetchClassList() {
  const { data } = await get('/api/classes/alist')
  const list = data.class_list || []
  setClassList(list)
}

export function setClassId(id: number) {
  store.commit('setClassId', id)
}

export function setDeviceList(list: ClassItem[] | null) {
  store.commit('setDeviceList', list)
}

const throttleHandlers: MapType<any> = {}

/**
 * 获取设备列表及其状态
 * @param autoSelect 是否在未选择任何项时，自动选择全部
 */
export async function fetchDeviceList({ autoSelect = false } = {}) {
  const classId = store.state.classId
  const query = classId ? { class_id: classId } : {}

  const handlerKey = JSON.stringify(query)
  let handler = throttleHandlers[handlerKey]

  if (handler == null) {
    handler = throttle(async () => {
      const { data } = await get('/api/play/client_status', query)

      const list = ((data.list as any[]) || []).map(
        it =>
          ({
            id: it.id,
            name: String(it.name),
            cmdMode: it.cmdMode == 1,
            isDownload: it.is_download == 1,
            isMute: it.is_mute == 1,
            isOnline: it.is_online == 1,
            isPlay: it.is_play == 1,
            lowBattery: it.lowBattery == 1,
            eyeUrl: it.eye_coordinates_url || ''
          } as DeviceItem)
      )
      setDeviceList(list)

      // 若没有选中任何设备，且 autoSelect 为 true，则默认选择全部在线设备
      if (autoSelect && store.state.selectedDeviceIds.length == 0) {
        const onlineIds = list.filter(it => it.isOnline).map(it => it.id)
        setSelectedDeviceIds(onlineIds)
      }
    }, 2000)
    throttleHandlers[handlerKey] = handler
  }

  handler()
}

export function setSelectedDeviceIds(ids: number[] | null) {
  store.commit('selectedDeviceIds', ids)
}

export async function shutdown(ids: number[]) {
  const pdata = { ids }
  await post('/api/play/shutdown_josn', pdata)
  fetchDeviceList()
}

export default store
